import Logo from '@passkeys/ui/logo';

import { cn } from '@/ui/utils/classnames';

const LOGO_SIZES = {
  small: 16,
  large: 24,
} as const;

type AvatarProps = {
  size: keyof typeof LOGO_SIZES;
  className?: string;
};

function Avatar({ size, className }: AvatarProps) {
  return (
    <div
      className={cn(
        'flex flex-none items-center justify-center rounded-full border border-pink-600 bg-pink-500',
        size === 'small' && 'size-6',
        size === 'large' && 'size-10',
        className,
      )}
    >
      <Logo size={LOGO_SIZES[size]} />
    </div>
  );
}

export default Avatar;
